import { getTokenClaims, setJwtToken } from '../services/auth.service';
import { EXTERNAL_PROVIDE_TOKEN } from '../config/cacheKey';

export const isTokenExpiredOrMissing = (): boolean => {
    const claims = getTokenClaims();
    const currentSeconds = Math.floor(Date.now() / 1000);

    if (!claims || !claims.exp) {
        return true;
    }

    const tokenExp = Number(claims.exp);

    if (tokenExp < currentSeconds) {
        return true;
    }

    return false;
};

export const clearTokenIfExpired = (): void => {
    if (isTokenExpiredOrMissing()) {
        localStorage.removeItem(EXTERNAL_PROVIDE_TOKEN);
        setJwtToken('', '');
    }
};
